<template>
    <Btn
        v-tooltip="active ? t('tooltip.unmark') : t('tooltip.mark')"
        variant="outlined"
        class="!flex protected-auth"
        color="slate-300"
        content-color="slate-600"
        active-content-color="yellow-300"
        :icon="active ? 'star-full' : 'star'"
        size="sm"
        :active="active"
    />
</template>

<script>
export default {
    name: 'ButtonBookmark',
    props: {
        active: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
